const companies = () => import('@/routes_new/inner/admin/companies/index.vue');
const companies_requests = () => import('@/routes_new/inner/admin/companies/requests/index.vue');
const companies_moderation = () =>
  import('@/routes_new/inner/admin/companies/moderation/index.vue');

const company = () => import('@/routes_new/inner/admin/company/index.vue');

import company_general from './company/general/index.vue';
import company_candidates from './company/candidates/index.vue';
import company_candidate from './company/candidates/candidate/index.vue';
import company_response_statuses from './company/response_statuses/index.vue';
import company_response_refill from './company/response_refill/index.vue';
import AdminCompanyRates from '@/routes_new/inner/admin/company/rates/AdminCompanyRates';
import company_vacancies from './company/vacancies/index.vue';
import company_vacancy from './company/vacancies/vacancy/index.vue';
import company_import from './company/import/index.vue';
import company_import_tasks from './company/import/tasks/index.vue';
import company_import_seekers from './company/import/seekers/index.vue';
import company_settings from './company/settings/index.vue';
import company_settings_common from './company/settings/common/index.vue';
import company_settings_managers from './company/settings/managers/index.vue';
import company_settings_modules from './company/settings/modules/index.vue';
import company_settings_email from './company/settings/email/index.vue';
import company_settings_domain from './company/settings/domain/index.vue';
import company_recruiters from './company/recruiters/index.vue';

const company_recruiter = () => import('./company/recruiters/recruiter/index.vue');
const company_recruiter_activity = () =>
  import('./company/recruiters/recruiter/recruiter_activity/index.vue');
const company_recruiter_vacancies = () =>
  import('./company/recruiters/recruiter/recruiter_vacancies/index.vue');
const company_recruiter_common = () =>
  import('./company/recruiters/recruiter/recruiter_common/index.vue');

const AdminSettings = () => import('@/routes_new/inner/admin/settings/AdminSettings');
const settings_users = () => import('@/routes_new/inner/admin/settings/users/index.vue');
const settings_user = () => import('@/routes_new/inner/admin/settings/users/user/index.vue');
const settings_languages = () => import('@/routes_new/inner/admin/settings/languages/index.vue');
const settings_templates = () => import('@/routes_new/inner/admin/settings/templates/index.vue');
const settings_integration = () =>
  import('@/routes_new/inner/admin/settings/integration/index.vue');
const settings_integration_amo = () =>
  import('@/routes_new/inner/admin/settings/integration/amo/index.vue');
const settings_integration_tilda = () =>
  import('@/routes_new/inner/admin/settings/integration/tilda/index.vue');
const settings_email = () => import('@/routes_new/inner/admin/settings/email/index.vue');
const settings_localization = () =>
  import('@/routes_new/inner/admin/settings/localization/index.vue');
const settings_special_processes = () =>
  import('@/routes_new/inner/admin/settings/special_processes/index.vue');
const settings_modules = () => import('@/routes_new/inner/admin/settings/modules/index.vue');
const settings_reports = () => import('@/routes_new/inner/admin/settings/reports/index.vue');

const responses = () => import('@/routes_new/inner/admin/responses/index.vue');
const response = () => import('@/routes_new/inner/admin/response/index.vue');
const response_general = () => import('@/routes_new/inner/admin/response/general/index.vue');
const response_tests = () => import('@/routes_new/inner/admin/response/tests/index.vue');
const response_videointerview = () =>
  import('@/routes_new/inner/admin/response/videointerview/index.vue');
const response_activity = () => import('@/routes_new/inner/admin/response/activity/index.vue');

export default [
  {
    path: 'companies',
    component: companies,
    name: 'admin-companies-list',
    meta: {
      title: 'pageTitles.routes.admin.companies',
      is_admin: true
    }
  },
  {
    path: 'companies-requests',
    component: companies_requests,
    name: 'admin-companies-requests',
    meta: {
      title: 'pageTitles.routes.admin.companies-requests',
      is_admin: true
    }
  },
  {
    path: 'companies-moderation',
    component: companies_moderation,
    name: 'admin-companies-moderation',
    meta: {
      title: 'pageTitles.routes.admin.companies-moderation',
      is_admin: true
    }
  },
  {
    path: 'settings',
    name: 'admin-settings',
    redirect: { name: 'admin-settings-users' },
    meta: {
      title: 'pageTitles.routes.admin.settings',
      is_admin: true
    },
    component: AdminSettings,
    children: [
      {
        path: 'users',
        component: settings_users,
        name: 'admin-settings-users',
        meta: {
          title: 'pageTitles.routes.admin.candidates',
          is_admin: true
        }
      },
      {
        path: 'users/:user_id',
        component: settings_user,
        props: route => ({
          userId: route.params.user_id
        }),
        name: 'admin-company-detailed-user-detailed',
        meta: {
          title: 'pageTitles.routes.admin.users',
          is_admin: true
        }
      },
      {
        path: 'languages',
        component: settings_languages,
        name: 'admin-settings-languages',
        meta: {
          title: 'pageTitles.routes.admin.locales',
          is_admin: true
        }
      },
      {
        path: 'templates',
        component: settings_templates,
        name: 'admin-settings-templates',
        meta: {
          title: 'pageTitles.routes.admin.candidates',
          is_admin: true
        }
      },
      {
        path: 'email',
        component: settings_email,
        name: 'admin-settings-email',
        meta: {
          title: 'pageTitles.routes.admin.candidates',
          is_admin: true
        }
      },
      {
        path: 'integration',
        component: settings_integration,
        name: 'admin-settings-integration',
        meta: {
          title: 'pageTitles.routes.admin.candidates',
          is_admin: true
        },
        redirect: { name: 'admin-settings-integration-amo' },
        children: [
          {
            path: 'amo',
            component: settings_integration_amo,
            name: 'admin-settings-integration-amo',
            meta: {
              title: 'pageTitles.routes.admin.candidates',
              is_admin: true
            }
          },
          {
            path: 'tilda',
            component: settings_integration_tilda,
            name: 'admin-settings-integration-tilda',
            meta: {
              title: 'pageTitles.routes.admin.candidates',
              is_admin: true
            }
          }
        ]
      },
      {
        path: 'localization',
        component: settings_localization,
        name: 'admin-settings-localization',
        meta: {
          title: 'pageTitles.routes.admin.candidates',
          is_admin: true
        }
      },
      {
        path: 'special-processes',
        component: settings_special_processes,
        name: 'admin-settings-special-processes',
        meta: {
          title: 'pageTitles.routes.admin.candidates',
          is_admin: true
        }
      },
      {
        path: 'reports',
        component: settings_reports,
        name: 'admin-settings-reports',
        meta: {
          title: 'pageTitles.routes.admin.reports',
          is_admin: true
        }
      },
      {
        path: 'modules',
        component: settings_modules,
        name: 'admin-settings-modules',
        meta: {
          title: 'pageTitles.routes.admin.modules',
          is_admin: true
        },
        children: [
          {
            path: 'videointerview',
            component: settings_modules,
            name: 'admin-settings-videointerview',
            meta: {
              title: 'videointerview',
              is_admin: true
            }
          },
          {
            path: 'test',
            component: settings_modules,
            name: 'admin-settings-test',
            meta: {
              title: 'videointerview',
              is_admin: true
            }
          }
        ]
      }
    ]
  },
  {
    path: 'company/:company_id',
    component: company,
    redirect: { name: 'admin-company-general' },
    props: route => ({
      companyId: route.params.company_id
    }),
    name: 'admin-company-detailed',
    meta: {
      title: 'pageTitles.routes.admin.vacancies',
      is_admin: true
    },
    children: [
      {
        path: 'candidates',
        component: company_candidates,
        props: route => ({
          companyId: route.params.company_id
        }),
        name: 'admin-company-detailed-candidates',
        meta: {
          title: 'pageTitles.routes.admin.candidates',
          is_admin: true
        }
      },
      {
        path: 'candidate/:response_id',
        component: company_candidate,
        props: route => ({
          response_id: route.params.response_id,
          companyId: route.params.company_id
        }),
        name: 'admin-company-detailed-candidate',
        meta: {
          title: 'pageTitles.routes.admin.candidates',
          is_admin: true
        }
      },
      {
        path: 'general',
        component: company_general,
        props: route => ({
          companyId: route.params.company_id
        }),
        name: 'admin-company-general',
        meta: {
          title: 'pageTitles.routes.admin.general',
          is_admin: true
        }
      },
      {
        path: 'response-statuses',
        component: company_response_statuses,
        props: route => ({
          companyId: route.params.company_id
        }),
        name: 'admin-company-response-statuses',
        meta: {
          title: 'pageTitles.routes.admin.response-statuses',
          is_admin: true
        }
      },
      {
        path: 'rates',
        component: AdminCompanyRates,
        props: route => ({
          companyId: route.params.company_id
        }),
        name: 'admin-company-rates',
        meta: {
          title: 'pageTitles.routes.admin.rates',
          is_admin: true
        }
      },
      {
        path: 'response-refill',
        component: company_response_refill,
        props: route => ({
          companyId: route.params.company_id
        }),
        name: 'admin-company-response-refill',
        meta: {
          title: 'pageTitles.routes.admin.response.refill',
          is_admin: true
        }
      },
      {
        path: 'recruiters',
        component: company_recruiters,
        props: route => ({
          companyId: route.params.company_id,
          is_add_recruiter: route.params.is_add_recruiter
        }),
        name: 'admin-company-detailed-recruiters',
        meta: {
          title: 'pageTitles.routes.admin.recruiters',
          is_admin: true
        }
      },
      {
        path: 'recruiters/:recruiter_id',
        redirect: { name: 'admin-company-detailed-recruiter-common' },
        component: company_recruiter,
        props: route => ({
          recruiterId: route.params.recruiter_id
        }),
        name: 'admin-company-detailed-recruiter-detailed',
        meta: {
          title: 'pageTitles.routes.admin.recruiters',
          is_admin: true
        },
        children: [
          {
            path: 'common',
            component: company_recruiter_common,
            props: route => ({
              recruiterId: route.params.recruiter_id
            }),
            name: 'admin-company-detailed-recruiter-common',
            meta: {
              title: 'pageTitles.routes.admin.recruiters',
              is_admin: true
            }
          },
          {
            path: 'vacancies',
            component: company_recruiter_vacancies,
            props: route => ({
              recruiterId: route.params.recruiter_id
            }),
            name: 'admin-company-detailed-recruiter-vacancies',
            meta: {
              title: 'pageTitles.routes.admin.recruiters',
              is_admin: true
            }
          },
          {
            path: 'activity',
            component: company_recruiter_activity,
            props: route => ({
              recruiterId: route.params.recruiter_id
            }),
            name: 'admin-company-detailed-recruiter-activity',
            meta: {
              title: 'pageTitles.routes.admin.recruiters',
              is_admin: true
            }
          }
        ]
      },
      {
        path: 'vacancies',
        component: company_vacancies,
        props: route => ({
          companyId: route.params.company_id
        }),
        name: 'admin-company-detailed-vacancies',
        meta: {
          title: 'pageTitles.routes.admin.vacancies',
          is_admin: true
        }
      },
      {
        path: 'vacancies/:vacancyId',
        component: company_vacancy,
        props: route => ({
          vacancyId: route.params.vacancyId
        }),
        name: 'admin-company-detailed-vacancies-vacancy',
        meta: {
          title: 'pageTitles.routes.admin.vacancies',
          is_admin: true
        }
      },
      {
        path: 'import',
        component: company_import,
        props: route => ({
          companyId: route.params.company_id
        }),
        name: 'admin-company-import',
        meta: {
          title: 'admin.company.board.title',
          is_admin: true
        },
        redirect: { name: 'admin-company-import-tasks' },
        children: [
          {
            path: 'tasks',
            component: company_import_tasks,
            props: route => ({
              companyId: route.params.company_id
            }),
            name: 'admin-company-import-tasks',
            meta: {
              title: 'admin.company.board.new_search',
              is_admin: true
            }
          },
          {
            path: 'seekers',
            component: company_import_seekers,
            props: route => ({
              companyId: route.params.company_id
            }),
            name: 'admin-company-import-seekers',
            meta: {
              title: 'admin.company.board.seekers',
              is_admin: true
            }
          }
        ]
      },
      {
        path: 'settings',
        component: company_settings,
        props: route => ({
          companyId: route.params.company_id
        }),
        name: 'admin-company-settings',
        meta: {
          title: 'pageTitles.routes.admin.company.settings',
          is_admin: true
        },
        redirect: { name: 'admin-company-settings-managers' },
        children: [
          {
            path: 'common',
            component: company_settings_common,
            props: route => ({
              companyId: route.params.company_id
            }),
            name: 'admin-company-settings-common',
            meta: {
              title: 'pageTitles.routes.admin.recruiters',
              is_admin: true
            }
          },
          {
            path: 'personal-managers',
            component: company_settings_managers,
            props: route => ({
              companyId: route.params.company_id
            }),
            name: 'admin-company-settings-managers',
            meta: {
              title: 'pageTitles.routes.admin.recruiters',
              is_admin: true
            }
          },
          {
            path: 'activity',
            component: company_settings_email,
            props: route => ({
              companyId: route.params.company_id
            }),
            name: 'admin-company-settings-email',
            meta: {
              title: 'pageTitles.routes.admin.recruiters',
              is_admin: true
            }
          },
          {
            path: 'domain',
            component: company_settings_domain,
            props: route => ({
              companyId: route.params.company_id
            }),
            name: 'admin-company-settings-domain',
            meta: {
              title: 'pageTitles.routes.admin.domain',
              is_admin: true
            }
          }
        ]
      },
      {
        path: 'modules',
        component: company_settings_modules,
        name: 'admin-company-settings-modules',
        meta: {
          title: 'pageTitles.routes.admin.recruiters',
          is_admin: true
        }
      }
    ]
  },
  {
    path: 'recruiters',
    component: company_recruiters,
    name: 'admin-recruiters',
    meta: {
      title: 'pageTitles.routes.admin.recruiters',
      is_admin: true
    }
  },
  {
    path: 'responses',
    component: responses,
    name: 'admin-responses',
    meta: {
      title: 'pageTitles.routes.admin.recruiters',
      is_admin: true
    }
  },
  {
    path: 'response/:response_id',
    component: response,
    redirect: { name: 'admin-response-general' },
    props: route => ({
      response_id: route.params.response_id
    }),
    name: 'admin-response',
    meta: {
      title: 'pageTitles.routes.admin.candidates',
      is_admin: true
    },
    children: [
      {
        path: 'general',
        component: response_general,
        props: route => ({
          response_id: route.params.response_id
        }),
        name: 'admin-response-general',
        meta: {
          title: 'pageTitles.routes.admin.candidates',
          is_admin: true
        }
      },
      {
        path: 'tests',
        component: response_tests,
        props: route => ({
          response_id: route.params.response_id
        }),
        name: 'admin-response-tests',
        meta: {
          title: 'pageTitles.routes.admin.candidates',
          is_admin: true
        }
      },
      {
        path: 'videointerview',
        component: response_videointerview,
        props: route => ({
          response_id: route.params.response_id
        }),
        name: 'admin-response-videointerview',
        meta: {
          title: 'pageTitles.routes.admin.candidates',
          is_admin: true
        }
      },
      {
        path: 'activity',
        component: response_activity,
        props: route => ({
          response_id: route.params.response_id
        }),
        name: 'admin-response-activity',
        meta: {
          title: 'pageTitles.routes.admin.candidates',
          is_admin: true
        }
      }
    ]
  }
];
